
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/soccer/player/[id]/[tab]",
      function () {
        return require("private-next-pages/soccer/player/[id]/[tab].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/soccer/player/[id]/[tab]"])
      });
    }
  